







import mixins from 'vue-typed-mixins';
import Report from '@/components/survey/report/Report.vue';
import SurveyUtils, { SurveyParticipation, Survey } from '@/utils/SurveyUtils';
import deepEqual from 'deep-equal';
import { ReportStore, ReportVM } from '@/utils/ReportUtils';
export default mixins().extend({
  components: {
    Report,
  },

  computed: {
    path: {
      get(): number[] {
        if (this.$route.params.path) {
          return this.$route.params.path
            .split('-')
            .map((element) => parseInt(element) - 1)
            .filter((element) => !isNaN(element));
        } else {
          return [];
        }
      },
      async set(path: number[]) {
        if (!deepEqual(this.path, path)) {
          await this.$router.push({
            name: 'survey-report',
            params: {
              ...this.$route.params,
              path: path?.map((index) => index + 1).join('-') || '1',
            },
          });
        }
      },
    },
    participation() {
      return ReportStore.surveyParticipation;
    },
  },

  data(): {
    ready: boolean;
  } {
    return {
      ready: false,
    };
  },

  async mounted() {
    try {
      const participation = await SurveyUtils.api.surveyParticipation.get(
        parseInt(this.$route.params.participantId)
      );
      if (participation) {
        participation.survey = await SurveyUtils.api.survey.get(
          participation.survey.id as number
        );
        ReportStore.path = this.path;
        ReportStore.surveyParticipation = participation;
        ReportStore.survey = ReportStore.surveyParticipation.survey as Survey;
        this.ready = true;
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  destroyed() {
    if (
      this.$session?.role?.type === 'admin' ||
      this.$session?.role?.type === 'superadmin'
    ) {
      // clear the survey when the report is navigated away from if the user is an admin
      ReportVM.clear();
    }
  },

  watch: {
    path() {
      ReportStore.path = this.path;
    },
  },
});
